import React from 'react';

import { styled } from '@mui/material';
import { imageUtil } from 'modules/layer0';



const StyledImg = styled('img')<{ widthPx?: number, heightPx?: number; }>(({ widthPx, heightPx }) => ({
  maxWidth: widthPx ?? 310,
  maxHeight: heightPx ?? 290
}));



export interface IProps {
  fileKey: string;

  widthPx?: number;
  heightPx?: number;
}

export const FC: React.FC<IProps> = props => {
  const fileUrl = React.useMemo(() => imageUtil.getFileUrl(props.fileKey), [props.fileKey]);

  return !props.fileKey ? null : (
    <StyledImg
      alt="API file"
      widthPx={props.widthPx}
      heightPx={props.heightPx}
      src={fileUrl} />
  );
};
